import { render, staticRenderFns } from "./LogisticsChartTask.vue?vue&type=template&id=4fc6b982&scoped=true"
import script from "./LogisticsChartTask.vue?vue&type=script&lang=js"
export * from "./LogisticsChartTask.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fc6b982",
  null
  
)

export default component.exports